module.exports = __webpack_public_path__ + "img/242a383.jpg";